import React from 'react'

/**
 * TimelineMarkers
 *
 * Renders vertical markers for shot boundaries.
 */
const TimelineMarkers = ({ shots, totalMs }) => {
  if (!shots || !totalMs) return null

  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        pointerEvents: 'none',
        zIndex: 5
      }}
    >
      {shots.map((shotWrapper, idx) => {
        const shotId = Object.keys(shotWrapper)[0]
        const shot = shotWrapper[shotId]
        if (!shot || shot.shot_start_ms == null) return null

        const left = (shot.shot_start_ms / totalMs) * 100
        return (
          <div
            key={idx}
            style={{
              position: 'absolute',
              left: `${left}%`,
              top: 0,
              bottom: 0,
              width: 1,
              borderLeft: '1px dashed rgba(0,0,0,0.2)',
              pointerEvents: 'none'
            }}
          />
        )
      })}
    </div>
  )
}

export default TimelineMarkers
